module.exports = "<simple-notifications [options]=\"notifyOptions\"></simple-notifications>\r\n<div class=\"card\">\r\n    <div class=\"card-block\">\r\n        Notes Addition\r\n    </div>\r\n    <div class=\"card-footer\" style=\"padding:5px\">\r\n        <a class=\"btn btn-secondary pull-right\" (click)=\"showNewModal()\">Add Note</a>\r\n\r\n    </div>\r\n\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/widgets/notes-textbox/notes-textbox.component.html
// module id = ./src/app/shared/components/widgets/notes-textbox/notes-textbox.component.html
// module chunks = main